import React from "react";
import styles from "./Footer.module.css";
import SocialShareIcons from "./SocialShareIcons";

const ContactInfo = ({ settings }) => {
  return (
    <div
      className={styles.columnWrapper}
      data-aos="fade-right"
      data-aos-delay="100"
    >
      <div className={styles.columnContent}>
        <div className={styles.columnHeader}>
          <h3 className={styles.columnHeading}>
            <div className={styles.columnHeadingWrapper}>
              <div className={styles.columnHeadingText}>Contact Us</div>
              <div className={styles.horizontalDivider} />
            </div>
            <div className={styles.columnHeadingUnderline} />
          </h3>
        </div>
        <div className={styles.spacer} />

        {/* Phone */}
        
        <a href={`tel:${settings?.contactNumber}`}>
          <div className={styles.contactItem}>
            <img
              src="/img/bodyshop/white-phone.svg"
              alt="Phone"
              className={styles.contactIcon}
            />
            {settings?.contactNumber && (
            <div className={styles.contactText}>
              <div className={styles.contactTextInner}>{settings?.contactNumber}</div>
            </div>
            )}
          </div>
        </a>
        <div className={styles.spacer} />

        {/* Email */}
        <a href={`mailto:${settings?.email}}`}>
          <div style={{ cursor: "pointer" }} className={styles.contactItem}>
            <img
              src="/img/bodyshop/white-mail.svg"
              alt="Email"
              className={styles.contactIcon}
            />
            {settings?.email && (
            <div className={styles.contactText}>
              <div className={styles.contactTextInner}>
                {settings?.email}
              </div>
            </div>
            )}
          </div>
        </a>
        <div className={styles.spacer} />

        {/* Location */}
        <div className={styles.contactItem}>
          <img
            src="/img/bodyshop/white-location.svg"
            alt="Location"
            className={styles.contactIcon}
          />
          <div className={styles.contactText}>
            <div className={styles.contactTextInner}>
              {settings?.address}
            </div>
          </div>
        </div>
        <div className={styles.spacer} />

        {/* Social Icons */}
        <div className={styles.spacer} />
        <SocialShareIcons  settings={settings} />
      </div>
    </div>
  );
};

export default ContactInfo;
